import { store } from '@/decorators/store';
import { Zone } from '@/entities/Zone';
import { AbstractEntityStore } from '@/stores/AbstractEntityStore';

@store({ id: 'ZoneStore' })
export class ZoneStore extends AbstractEntityStore<Zone> {
  protected entityIdKey = 'properties.code';
  protected entityLabelKey = 'properties.name';
  protected entityValueKey = 'properties.name';
}
